import TextInput from 'components/refinedev/TextInput';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import SelectInput from 'components/refinedev/SelectInput';
import {useEffect, useRef, useState} from 'react';
import Section from 'components/surface/Section';
import {toast} from 'react-toastify';
// import CheckboxInput from 'components/refinedev/CheckboxInput';
import {faker} from '@faker-js/faker';
import RadioInput from 'components/refinedev/RadioInput';
import DatepickerInput from 'components/refinedev/DatepickerInput';
// import AutocompleteInput from '@/components/refinedev/AutocompleteInput';
import SelectMultipleInput from '@/components/refinedev/SelectMultipleInput';
import {Button} from '@/shadcn_components/ui/button';
// import AutocompleteArrayInput from '@/components/refinedev/AutocompleteArrayInput';
import {FormProvider, useForm} from 'react-hook-form';
import CheckboxInput from '@/components/refinedev/CheckboxInput';
import {dirtyValues} from '@/lib/react-hook-form-helpers';
import {Separator} from '@/shadcn_components/ui/separator';
import AutocompleteInput from '@/components/refinedev/AutocompleteInput';
import AutocompleteArrayInput from '@/components/refinedev/AutocompleteArrayInput';
import {useNotification} from '@refinedev/core';
import * as datefns from 'date-fns';
import IMask from 'imask';
import {MaskTextInput, ThousandSeparatorTextInput} from '@/components/refinedev/MaskTextInput';
import {Input} from '@/shadcn_components/ui/input';
import {ProjectAutocompleteInput} from '../resources/projects/components/project-autocomplete-input';
import ColorPickerInput from '@/components/refinedev/ColorPickerInput';
import { AmountParametersDialog } from '../resources/estimate/amount-parameters-dialog';

const schema = yup
  .object()
  .shape({
    title: yup.string().required(),
    test_select: yup.number().min(2, 'Phải từ 2 trở lên'),
    check1: yup.boolean().isTrue('must ..'),
  })
  .required();

const resolver = yupResolver(schema);

faker.seed(111);
let id = 1;
const allData = faker.helpers.multiple(
  () => ({
    id: id++,
    label: faker.person.fullName(),
  }),
  {count: 100},
);

const TestFormSubmit = () => {
  const notification = useNotification();

  const [data, setData] = useState<any>();
  // const [_search, setSearch] = useState('');
  // const {data: parentList} = useParentList({
  //   filter: {_search},
  // });
  // const {data: list_pp} = useGetMany('parents', {ids: [3, 5]});
  // record={{

  // }}
  // onSubmit={data => {
  //   console.log(data);
  //   setData(data);
  // }}
  // resolver={resolver}

  const useFormResults = useForm({
    // defaultValues: {
    //   check1: true,
    //   title: 'ABCD',
    //   content: 'Content1',
    //   test_select: 2,
    //   // list_pp: [3, 5], //list_pp || [],
    //   radio_test: 3,
    //   date: {from: '2024-03-05', to: '2024-03-20'},
    //   ms: [{id: 4}, {id: 5}],
    // },
  });
  const {watch} = useFormResults;

  const check1 = watch('check1');

  function fillData() {
    const data = {
      investment_value: 1000000,
      check1: false,
      title: 'ABCD',
      content: 'Content1',
      test_select: 2,
      // list_pp: [3, 5], //list_pp || [],
      radio_test: 3,
      date1: new Date(),
      date_range: {from: '2024-03-05', to: '2024-03-20'},
      ms: [{id: 4}, {id: 5}],
      recipient_parents: [1, 2],
      ss: 4,
      members: [1, 2, 5].map(id => ({id})),
    };
    for (const k in data) {
      useFormResults.setValue(k, data[k]);
    }
  }

  const maskProps = {
    mask: Date,
    pattern: '`d{/}`m{/}`Y',
    min: new Date(1900, 0, 1),
    max: new Date(2100, 0, 1),
    lazy: false,
    format: date => datefns.format(date, 'dd/MM/yyyy'),
    parse: str => datefns.parse(str, 'dd/MM/yyyy', new Date()),
    blocks: {
      d: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
        maxLength: 2,
      },
      m: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
        maxLength: 2,
      },
      Y: {
        mask: IMask.MaskedRange,
        from: 1900,
        to: 2100,
      },
    },
  };

  const formData = useFormResults.watch();
  // console.log('form value', formData);

  async function onSubmit(data) {
    const dirtyOnly = dirtyValues(useFormResults.formState.dirtyFields, data);
    console.log('onSubmit', data, dirtyOnly);
  }

  const {handleSubmit} = useFormResults;

  return (
    <>
      <FormProvider {...useFormResults}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-row">
            <div className="max-w-2xl">
              <Section title="Nhập thông tin" subtitle="Mô tả nhập thông tin">
                <AmountParametersDialog
                  parameters={{amount_type:'area'}}
                  onSave={(e)=>console.log(e)}
                  readOnly={false}
                />
                <ColorPickerInput source="color" label="Màu" />
                <ProjectAutocompleteInput source="project" label="Dự án" />
                <DatepickerInput source="date1" label="Ngày" />
                <DatepickerInput source="date_range" label="Dải Ngày" calendar={{mode: 'range'}} />

                <ThousandSeparatorTextInput source="investment_value" label="Số tiền đầu tư" />
                <AutocompleteArrayInput
                  source="members"
                  reference="staffs"
                  label="Nhân viên tham gia"
                  autoCompleteProps={{optionText: 'name'}}
                  renderSelectedItems={(items, removeAt) => {
                    return items.map((item, index) => (
                      <div key={item.id} className="flex flex-row gap-x-2">
                        {item.name}
                        <TextInput source={`members.${index}.role` as const} label="Vai trò" />
                      </div>
                    ));
                  }}
                />
                <CheckboxInput source="check11" label="Check1" />
                <TextInput source="title" label="Default Input" />
                <TextInput source="content" label="Disabled" disabled />
                <TextInput source="nested.value1" label="Nested-value1" />
                <TextInput source="nested.value2" label="Nested-value2" />
                <SelectInput
                  source="test_select"
                  label="Chọn"
                  choices={[
                    {
                      id: 1,
                      label: 'Chọn 1',
                    },
                    {
                      id: 2,
                      label: 'Chọn 2',
                    },
                    {
                      id: 3,
                      label: 'Chọn 3',
                    },
                  ]}
                />
                <DatepickerInput
                  calendar={{mode: 'range', numberOfMonths: 2}}
                  source="date"
                  label="Nhập ngày"
                  dismissOnSelect={false}
                />
                <RadioInput
                  source="radio_test"
                  label="Radio test"
                  choices={[
                    {
                      id: 1,
                      label: 'Chọn 1',
                    },
                    {
                      id: 2,
                      label: 'Chọn 2',
                    },
                    {
                      id: 3,
                      label: 'Chọn 3',
                    },
                  ]}
                />
                {/* {check1 && <ParentArrayInput />} */}
                <AutocompleteInput
                  source="ss"
                  label="Autocomplete test"
                  reference="staffs"
                  autoCompleteProps={{
                    EmptyValue: true,
                    placeholder: 'Chọn người nhận',
                    getOptionText: c => c.name,
                    renderOption: c => (
                      <p className="text-blue-800 text-sm">
                        {c.name} ({c.mobile})
                      </p>
                    ),
                  }}
                />
                {/* <ChoicesProviderContext resource="parents">
              <AutocompleteInput                
                source="pp"
                label="Autocomplete test"
                getOptionText={c => c.father_name}
                renderOption={c => (
                  <Typography className="text-blue-800">
                    {c.father_name} ({c.father_mobile})
                  </Typography>
                )}
              />
            </ChoicesProviderContext> */}
                {/* <AutocompleteArrayInput
              source="list_pp"
              reference="parents"
              autoCompleteProps={{
                placeholder: 'place holder is here',
                getOptionText: c => c.father_name,
                renderOption: c => (
                  <p className="text-blue-800">
                    {c.father_name} ({c.father_mobile})
                  </p>
                ),
              }}
              renderPreview={(items, removeAt) => (
                <div
                  className={'flex flex-wrap bg-white p-2 w-full max-h-96 overflow-y-auto gap-1'}>
                  {(items || []).map((item, i) => (
                    <Chip
                      key={i}
                      value={`${item.father_name} (${item.father_mobile})`}
                      onClose={() => removeAt(i)}
                    />
                    // <div className="text-blue-800 border border-gray-400 rounded-md" key={i}>
                    //   {item.father_name} ({item.father_mobile})
                    //   <Button
                    //     variant="ghost"
                    //     size="sm"
                    //     className="p-1"
                    //     color="red"
                    //     onClick={() => removeAt(i)}>
                    //     <XMarkIcon className="w-5 h-5" />
                    //   </Button>
                    // </div>
                  ))}
                </div>
              )}
            /> */}
                <SelectMultipleInput source="ms" choices={allData} label="Test multiple select" />
              </Section>
            </div>
            <div className="max-w-2xl">
              <div>{JSON.stringify(formData)}</div>
              <Separator />
              <div>{JSON.stringify(useFormResults.formState.dirtyFields)}</div>
            </div>
          </div>
          <div>
            <Button type="submit">Save</Button>
            <Button
              type="button"
              onClick={() =>
                notification.open?.({
                  message: 'Helllo' + new Date().getTime(),
                  description: 'Mô tả dài dòng?',
                  type: 'success',
                })
              }
              variant="outline"
              color="blue">
              Show notification
            </Button>
            <Button type="button" onClick={fillData}>
              Fill data
            </Button>
          </div>
        </form>
      </FormProvider>
    </>
  );
};

function MaskedDateInput() {
  const [date, setDate] = useState(''); // Holds the raw date as a string
  const inputRef = useRef<any>(null);
  const maskRef = useRef<any>(null);

  useEffect(() => {
    if (inputRef.current) {
      maskRef.current = IMask(inputRef.current, {
        mask: Date,
        pattern: 'd{/}`m{/}`Y',
        lazy: false,
        blocks: {
          d: {mask: IMask.MaskedRange, from: 1, to: 31, maxLength: 2},
          m: {mask: IMask.MaskedRange, from: 1, to: 12, maxLength: 2},
          Y: {mask: IMask.MaskedRange, from: 1900, to: 2100},
        },
        format: date => datefns.format(date, 'dd/MM/yyyy'), // Formats for display
        parse: str => datefns.parse(str, 'dd/MM/yyyy', new Date()), // Parses input to Date
      });

      // Handle changes
      maskRef.current.on('accept', () => {
        const maskedValue = maskRef.current.value;
        const parsedDate = datefns.parse(maskedValue, 'dd/MM/yyyy', new Date());

        // Store the formatted date or empty if invalid
        setDate(maskedValue.length === 10 ? datefns.format(parsedDate, 'yyyy-MM-dd') : '');
      });
    }

    return () => maskRef.current?.destroy();
  }, []);

  return (
    <Input
      ref={inputRef}
      value={date} // Holds the raw value in YYYY-MM-DD format
      onChange={e => setDate(e.target.value)} // Keeps it controlled
    />
  );
}

export default TestFormSubmit;
